
const digest = '70139bd526800c630367a267b66584159246cd100cb910528e061cd8fed2c1c7';
const classes = {"wrapper":"_wrapper_1n24u_1","textBold":"_textBold_1n24u_6","controls":"_controls_1n24u_10"};
const css = `._wrapper_1n24u_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1n24u_1 ._textBold_1n24u_6 {
  text-align: center;
  font-weight: 500;
}
._wrapper_1n24u_1 ._controls_1n24u_10 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  